import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "card-group d-flex justify-content-left justify-content-lg-start" }
const _hoisted_2 = { class: "row mt-2" }
const _hoisted_3 = { class: "col-1 offset-8 order-1" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("b", null, "Anterior", -1)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = { class: "col-1 order-1" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("b", null, "Siguiente", -1)
const _hoisted_8 = [
  _hoisted_7
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MessageComponent = _resolveComponent("MessageComponent")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.devices, (device) => {
        return (_openBlock(), _createBlock(_component_MessageComponent, {
          key: device.id,
          device: device,
          onDeviceModified: _ctx.reorder
        }, null, 8, ["device", "onDeviceModified"]))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("button", {
          class: "btn btn-primary",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.loadLess && _ctx.loadLess(...args)))
        }, _hoisted_5)
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("button", {
          class: "btn btn-success",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.loadMore && _ctx.loadMore(...args)))
        }, _hoisted_8)
      ])
    ])
  ], 64))
}